import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ParentChild1"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 9C21.8284 9 22.5 8.32843 22.5 7.5V3C22.5 2.17157 21.8284 1.5 21 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V7.5C1.5 8.32843 2.17157 9 3 9H11.25V12H6.75C5.92157 12 5.25 12.6716 5.25 13.5V16.5H3C2.17157 16.5 1.5 17.1716 1.5 18V21C1.5 21.8284 2.17157 22.5 3 22.5H9C9.82843 22.5 10.5 21.8284 10.5 21V18C10.5 17.1716 9.82843 16.5 9 16.5H6.75V13.5H17.25V16.5H15C14.1716 16.5 13.5 17.1716 13.5 18V21C13.5 21.8284 14.1716 22.5 15 22.5H21C21.8284 22.5 22.5 21.8284 22.5 21V18C22.5 17.1716 21.8284 16.5 21 16.5H18.75V13.5C18.75 12.6716 18.0784 12 17.25 12H12.75V9H21ZM9 21H3V18H9V21ZM21 21H15V18H21V21ZM3 3H21V7.5H3V3Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ParentChild1.vue"]]);
